import { ChangeDetectionStrategy, Component, computed, effect, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { CarteOpportunites } from '@components/carte-opportunites/models';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/components/button';
import { MapComponent } from '@shared/components/map';
import { MapConfig } from '@shared/components/map/models';
import { SvgComponent } from '@shared/components/svg';
import { ElasticSearchService } from '@shared/services/elastic-search';
import { LogsService } from '@shared/services/logs';
import { StoreLocatorStore } from '@stores';
import { take } from 'rxjs';

@Component({
  selector: 'app-carte-opportunites',
  imports: [SvgComponent, MapComponent, TranslatePipe, ButtonComponent],
  templateUrl: './carte-opportunites.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarteOpportunitesComponent
  extends AbstractDynamicComponent<CarteOpportunites>
  implements OnInit, OnDestroy
{
  protected showOpenStores = signal(true);
  protected showOpeningOpportunities = signal(true);
  protected opportunitiesConfig = computed<MapConfig>(() => ({
    showOpenStores: this.showOpenStores(),
    showOpeningOpportunities: this.showOpeningOpportunities(),
    isMapViewForOpportunities: true,
  }));
  protected opportunitiesOverseas = signal<string[]>([]);
  private readonly storeLocatorStore = inject(StoreLocatorStore);
  private readonly logs = inject(LogsService);
  private readonly elasticSearchService = inject(ElasticSearchService);

  constructor() {
    super();
    effect(() => {
      const opportunities = this.storeLocatorStore.select('opportunities')() ?? [];
      this.opportunitiesOverseas.set(opportunities.filter((o) => o.isOverseas).map((o) => o.name));
    });
  }

  ngOnInit() {
    this.logs.debug('CarteOpportunitesComponent', 'Get All Stores and All Opportunities');
    this.storeLocatorStore.update('opportunityContactUrl', this.data.contactUrl ?? '');
    this.elasticSearchService
      .getAllStores()
      .pipe(take(1))
      .subscribe({ error: (err) => this.logs.error('CarteOpportunitesComponent', 'getAllStores failed', err) });
    this.elasticSearchService
      .getStoreOpporunities()
      .pipe(take(1))
      .subscribe({ error: (err) => this.logs.error('CarteOpportunitesComponent', 'getStoreOpporunities failed', err) });
  }

  onShowOpenStoresChange($event: Event) {
    const target = $event.target as HTMLInputElement;
    this.showOpenStores.set(target.checked);
  }

  onShowOpeningOpportunitiesChange($event: Event) {
    const target = $event.target as HTMLInputElement;
    this.showOpeningOpportunities.set(target.checked);
  }

  ngOnDestroy(): void {
    this.storeLocatorStore.delete('opportunities');
  }
}
